// extracted by mini-css-extract-plugin
export default {"head":"videoView_head__Luwm2"};